import Indicator, { IndicatorType } from './types/Indicator'

const Value: Indicator = {
  type: IndicatorType.PRICE,
  value: 'value',
  label: 'Value',
  fields: ['value'],
}

export default Value
